import React from "react";
import Avatar from 'react-avatar';
import axios from "axios";
import { connect } from "react-redux";
import './headerprofile.css';
import moment from "moment";
import { store } from "../../redux/store";
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
import { setAgentId, setConsumerProfile, setFullName } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();
class HeaderProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            fullName: '',
            agentId: ''
        }
    }


    componentDidMount() {
        this.getProfile()
    }
    componentWillUnmount() {
    }

    getProfile = () => {
        if (this.props.consumerProfile != undefined &&
            this.props.consumerProfile != null &&
            this.props.consumerProfile != "") {

        } else {
            const headers = {
                'Authorization': 'Bearer ' + this.props.token,
                'client-id': this.props.agentInfo,
                'role': this.props.clientRole
            }

            httpClient.get('/api/v1/retailer/get/'
                + this.props.agentInfo,
                { headers }
            ).then((response) => {
                store.dispatch(setConsumerProfile(response.data));
                console.log('get Profile Response' + JSON.stringify(response.data));

                var fullName = '';
                if (response.data.personalInfo != null) {
                    var fname = (response.data.personalInfo.fname != "" &&
                        response.data.personalInfo.fname != null &&
                        response.data.personalInfo.fname != undefined) ?
                        response.data.personalInfo.fname : "";
                    var lname = (response.data.personalInfo.lname != "" &&
                        response.data.personalInfo.lname != null &&
                        response.data.personalInfo.lname != undefined) ?
                        response.data.personalInfo.lname : "";
                    fullName = fname + " " + lname;
                }
                store.dispatch(setFullName(fullName));
                store.dispatch(setAgentId(response.data.id));

                this.setState({
                    fullName: fullName,
                    agentId: response.data.id
                })

            }).catch(error => {

                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                }
            });
        }

    }



    render() {

        return (

            <div class="col-12 col-lg order-lg-3">
                <div class="card">
                    <div class="profile-box">
                        <div class="dropdown">
                            {this.props.fullName != undefined &&
                                this.props.fullName != "" &&
                                this.props.fullName != null &&
                                <button type="button" class="dropdown-toggle" id="promenu" data-bs-toggle="dropdown" aria-expanded="false">
                                    <Avatar name={this.props.fullName} size={40} round={true} textSizeRatio={2.5} />

                                </button>
                            }

                            <div class="dropdown-menu dropdown-menu-end" aria-labelledby="promenu">
                                <ul>
                                    <li><Link to="/profile" class="pro">Profile</Link></li>
                                    {/* <!--<li><a href="payment-request.html" class="pay">Payment Request</a></li>--> */}
                                    {/* <li><a href="/activity-log" class="act">Activity Log</a></li> */}
                                    {this.props.logOutEnabled == "true" &&
                                        <li><Link to="/login" class="log">Logout</Link></li>
                                    }
                                </ul>
                            </div>
                        </div>
                        {this.props.fullName != undefined &&
                            this.props.fullName != "" &&
                            this.props.fullName != null &&
                            <p>Welcome! <span>{this.props.fullName}</span></p>
                        }
                        {this.props.consumerAgent != undefined &&
                            this.props.consumerAgent != "" &&
                            this.props.consumerAgent != null &&
                            <p>RO ID: <span>{this.props.consumerAgent}</span></p>
                        }

                    </div>
                    <div class="last-login">
                        <p>Last Login:  <span>{moment(this.props.loginTime).format('DD-MM-YYYY HH:mm:ss')}</span></p>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage },
        miscReduce: { phone, agentInfo, token, clientRole, loginTime,
            fullName, consumerAgent, consumerProfile,logOutEnabled } }
) => ({
    errorMessage, phone, agentInfo, token, clientRole, loginTime,
    fullName, consumerAgent, consumerProfile,logOutEnabled
});

export default connect(mapStateToProps, null)(HeaderProfile);
